var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "ul",
        { staticClass: "unstyled" },
        [
          _vm._l(_vm.options, function(option) {
            return _c(
              "li",
              {
                key: option.identifier,
                class: {
                  chosen: _vm.isChosen(option),
                  "other-textarea-visible": _vm.shouldShowTextareaFor(option)
                },
                on: {
                  click: function($event) {
                    return _vm.chooseOption(option)
                  }
                }
              },
              [_vm._v("\n      " + _vm._s(option.verbose) + "\n    ")]
            )
          }),
          _vm._v(" "),
          _c("transition", { attrs: { name: "fade-fast" } }, [
            _vm.otherOptionChosen
              ? _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.otherOptionText,
                      expression: "otherOptionText"
                    }
                  ],
                  ref: "other_textarea",
                  staticClass: "other-textarea",
                  attrs: { placeholder: "If other, please explain" },
                  domProps: { value: _vm.otherOptionText },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.otherOptionText = $event.target.value
                    }
                  }
                })
              : _vm._e()
          ])
        ],
        2
      ),
      _vm._v(" "),
      !_vm.validOtherOption
        ? _c("p", { staticClass: "error" }, [
            _c("small", [
              _vm._v(
                _vm._s(_vm.otherOptionRemainingChars) + " characters remaining"
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("TrialCancellationActionsUi", {
        attrs: {
          loading: _vm.loading,
          "continue-disabled": !_vm.canContinue,
          "abort-btn-text": _vm.abortBtnText
        },
        on: { continue: _vm.postSurveyResults, abort: _vm.abortHandler }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }